import { useEffect, useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import Api from "../../../../../constants/Api";

// Cache em módulo: evita refazer o download da mesma foto ao reordenar/remover
// itens da lista de venda (o componente é remontado quando a linha muda de posição).
const imageCache = {};

/**
 * Miniatura da foto do produto, usada na lista de itens da venda.
 * Busca a imagem em base64 só quando o produto tem arquivo enviado (hasPhoto);
 * caso contrário (ou se o download falhar) exibe um placeholder.
 */
const ProductThumbnail = ({ productId, hasPhoto, alt, size = 40 }) => {
    const [imageUrl, setImageUrl] = useState(imageCache[productId] || null);
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!hasPhoto || !productId) return;

        if (imageCache[productId]) {
            setImageUrl(imageCache[productId]);
            return;
        }

        setLoading(true);
        setFailed(false);

        axiosInstance.get(Api.main.product + "/download/base64/" + productId)
            .then((response) => {
                if (response.data) {
                    const url = "data:image/jpeg;base64," + response.data;
                    imageCache[productId] = url;
                    setImageUrl(url);
                } else {
                    setFailed(true);
                }
            })
            .catch(() => setFailed(true))
            .finally(() => setLoading(false));
    }, [productId, hasPhoto]);

    const style = { width: size, height: size };

    if (hasPhoto && !failed && (imageUrl || loading)) {
        return (
            <div className="product-thumbnail" style={style}>
                {imageUrl ? (
                    <img src={imageUrl} alt={alt} className="product-thumbnail__img" />
                ) : (
                    <span className="product-thumbnail__spinner">
                        <i className="fas fa-spinner fa-spin"></i>
                    </span>
                )}
            </div>
        );
    }

    return (
        <div className="product-thumbnail product-thumbnail--placeholder" style={style}>
            <i className="fas fa-image"></i>
        </div>
    );
};

export default ProductThumbnail;
